function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.75 15.954v1.69c1.15-1.458 3.348-2.059 5.285-1.341l.684.255a.433.433 0 0 1 .248.22c.045.099.044.21-.004.308l-.291.599C17.987 19.089 16.408 20 14.662 20a4.85 4.85 0 0 1-1.697-.303l-.215-.081v.634a.75.75 0 1 1-1.5 0v-.633l-.215.08c-.537.2-1.114.303-1.697.303-1.747 0-3.325-.91-4.01-2.315l-.291-.599a.357.357 0 0 1-.004-.308.435.435 0 0 1 .248-.22l.684-.255c1.937-.718 4.136-.116 5.286 1.342v-1.679a7.084 7.084 0 0 0 1.5-.012z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.941 3a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm-1.38 3.854a.5.5 0 1 0-.707.707l.398.398a1.99 1.99 0 0 0-.277 1.016c0 .37.1.718.276 1.015l-.397.4a.5.5 0 1 0 .707.706l.398-.398a1.99 1.99 0 0 0 1.016.277c.37 0 .718-.101 1.015-.277l.4.398a.5.5 0 0 0 .706-.707l-.398-.399a1.99 1.99 0 0 0 .277-1.015 1.99 1.99 0 0 0-.277-1.016l.398-.398a.5.5 0 0 0-.707-.707l-.399.397a1.99 1.99 0 0 0-1.015-.276 1.99 1.99 0 0 0-1.016.277zm1.414 1.12a1 1 0 1 1 0 2 1 1 0 0 1 0-2z",
  fillRule: "nonzero"
}));

function SvgIco24GnbFarmingS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24GnbFarmingS);
export default __webpack_public_path__ + "static/media/ico_24_gnb_farming_s.5c9b4275.svg";
export { ForwardRef as ReactComponent };